<template>
  <pibot-mapbox-datatable-popup v-bind="$options.propsData">
    <template #title>
      <p class="text-body-2 ma-0">
        {{properties['Feature Type']}}
      </p>
      <p class="text-overline ma-0">
        {{properties['Pipeline Name']}} - {{properties['Inspection Year']}} <span v-if="properties['Inspection Type']">{{properties['Inspection Type']}}</span>
      </p>
    </template>
  </pibot-mapbox-datatable-popup>
</template>

<script>
import DataTablePopup from './DataTablePopup'

export default {
  name: 'pibot-mapbox-ili-popup',
  inheritAttrs: false,
  components: {
    'pibot-mapbox-datatable-popup': DataTablePopup
  },
  computed: {
    properties () {
      return this.$options.propsData.feature.properties
    }
  }
}
</script>
